/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var SearchProductPropertyVal;
(function (SearchProductPropertyVal) {
    var operator;
    (function (operator) {
        operator["GT"] = "GT";
        operator["GTE"] = "GTE";
        operator["LT"] = "LT";
        operator["LTE"] = "LTE";
        operator["EQ"] = "EQ";
        operator["NE"] = "NE";
        operator["AND"] = "AND";
        operator["OR"] = "OR";
        operator["BEGINS"] = "BEGINS";
        operator["MATCH_ALL"] = "MATCH_ALL";
        operator["MATCH_ANY"] = "MATCH_ANY";
        operator["MATCH_PHRASE"] = "MATCH_PHRASE";
        operator["EXISTS"] = "EXISTS";
        operator["NOT_EXISTS"] = "NOT_EXISTS";
        operator["WILDCARD"] = "WILDCARD";
    })(operator = SearchProductPropertyVal.operator || (SearchProductPropertyVal.operator = {}));
})(SearchProductPropertyVal || (SearchProductPropertyVal = {}));
